import React from 'react';

const Disclaimer = () => {
  return (
    <>
    <div className='disclaimer px-5 mt-6 text-black mx-4'>
    <h1 className='text-center text-2xl py-10 font-bold'> Cancellation & Refund Policy </h1>
Last updated: 2022-11-01<br/><br/>
<a className='text-lg font-medium '>CRC Bharat (CRC) believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:</a><br />

<li className="py-2">Cancellations will be considered only if the request is made immediately after placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.</li>

<li className="py-2">CRC Bharat (CRC) does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.</li>

<li className="py-2">In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within same day of receipt of the products.</li>

<li className="py-2">In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within same day of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.</li>

<li className="py-2">In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.</li>

<li className="py-2">In case of any Refunds approved by the CRC Bharat (CRC), it’ll take 1-2 days for the refund to be processed to the end customer.</li>

</div>
</>
  )
}

export default Disclaimer